import moment from 'moment';

const initialState = {
    userInfo: [],
    lastFetch: moment(),
    apiKey: "initKey"
}

export default function appReducer(state = initialState, action) {//Best practices for Redux is to split the master reducer into reducer slices based on functionality in different functions (and usually in different .js files).
    //This is mostly for readability, to which I say: if you don't know what CTRL-F does, that's a skill issue. Besides, the only thing we really need this for so far is to manage user info, auth token, and when the user
    //last did something. Most if not all other data can either be managed within state or passed as prop. The only other thing that this could be useful for is the department switch to new page callback, and frankly that's not
    //enough of an issue site-wide to justify re-engineering the process the way we should be doing with the repeated UserController fetches and storing bearer tokens in local storage (barf).
    //That said, if at some point in the future this needs to expand, keep the idea in the back of your mind.
    switch (action.type) {
        case 'foundation/setUserData': {
            return {
                ...state,
                userInfo: action.payload
            }
        }
        case 'foundation/setFetchTime': {
            return {
                ...state,
                lastFetch: moment()
            }
        }
        case 'foundation/setApiKey': {
            return {
                ...state,
                apiKey: action.payload
            }
        }
        default:
            return state
    }
}